import { Injectable } from '@angular/core';
import { FeatureFlags, FeatureFlagsServiceBase } from '@skylab-shared/config';

@Injectable({providedIn: 'root'})
export class FeatureFlagsService {
    private featureFlagsServiceBase = new FeatureFlagsServiceBase();

    public set flags(val) {
        this.featureFlagsServiceBase.flags = val;
    }

    public get flags(): FeatureFlags {
        return this.featureFlagsServiceBase.flags;
    }
}
